import { Component } from '@angular/core';
import { TypedDialog } from 'shared/ui';

@Component({
  selector: 'viewer-new-feature-1-alert',
  templateUrl: './new-feature-1-alert.component.html',
  styleUrl: './new-feature-1-alert.component.scss',
})
export class NewFeature1AlertComponent extends TypedDialog<void, boolean> {}
